<template>
<div class="view">
  <loader v-if="loader"></loader>

  <div class="background" ref="background">
    <div class="background__overlay"></div>
    <div class="background__image" :style="'background-image: url(' + brand.image + ')'"></div>
  </div>

  <header class="header" ref="header">
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <div class="header-container">
          <div class="header__left">
            <div class="hamburger-menu" @click="visibleNavigation = true">
              <div class="hamburger-menu__icon">
                <i class="material-icons">menu</i>
              </div>
            </div>
          </div>
          <div class="header__center">
            <h1 class="header__title">{{ brand.name }}</h1>
          </div>
          <div class="header__right">
            <div class="notification" v-on:click="toggleNotification" ref="notificationBtn">
              <div class="notification__icon">
                <i class="material-icons">notifications</i>
              </div>
              <div class="notification__count" v-if="card.count.notification > 0">{{ card.count.notification }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main v-cloak>
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <div class="card__container" ref="card__container">
          <div class="card" :style="'background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, .75) 100%), url(' + card.image + '), linear-gradient(-180deg, rgba(57, 57, 57, .5) 0%, rgba(57, 57, 57, .5) 100%)'" v-on:click="toggelVerify()">
            <div
              class="card__info"
              v-if="user.cell !== ''"
            >
              <div class="card__avatar">
                <img :src="user.avatar || '/assets/img/vip/default_avatar.svg'">
              </div>
              <div class="card__name">
                {{ user.name }}
              </div>
              <div class="card__type">
                {{ card.type }}
              </div>
            </div>
            <div class="card__tool card__tool--detail" v-if="card.verifyType === 4 && card.ultrasound">
              <svg class="card__tool-icon" viewBox="0 0 12 16"  xmlns="http://www.w3.org/2000/svg" width="12" height="16">
                  <g fill="none" fill-rule="evenodd">
                      <g transform="translate(-339.000000, -204.000000)" fill="#FFFFFF">
                          <path d="M349.34375,204.6875 C349.697918,204.6875 350.005207,204.817707 350.265625,205.078125 C350.526043,205.338543 350.65625,205.645832 350.65625,206 L350.65625,217.34375 C350.65625,217.697918 350.526043,218.005207 350.265625,218.265625 C350.005207,218.526043 349.697918,218.65625 349.34375,218.65625 L347.9375,218.65625 C347.875,217.760412 347.666668,216.875004 347.3125,216 L349.34375,216 L349.34375,207.34375 L342.65625,207.34375 L342.65625,211.34375 C342.135414,211.114582 341.697918,210.96875 341.34375,210.90625 L341.34375,206 C341.34375,205.645832 341.473957,205.333335 341.734375,205.0625 C341.994793,204.791665 342.302082,204.65625 342.65625,204.65625 L349.34375,204.6875 Z M339.34375,212 C341.364593,212 343.088535,212.713535 344.515625,214.140625 C345.942715,215.567715 346.65625,217.302073 346.65625,219.34375 L345.34375,219.34375 C345.34375,217.697908 344.755214,216.286464 343.578125,215.109375 C342.401036,213.932286 340.989592,213.34375 339.34375,213.34375 L339.34375,212 Z M339.34375,217.34375 C339.885419,217.34375 340.354165,217.541665 340.75,217.9375 C341.145835,218.333335 341.34375,218.802081 341.34375,219.34375 L339.34375,219.34375 L339.34375,217.34375 Z M339.34375,214.65625 C340.635423,214.65625 341.73437,215.114579 342.640625,216.03125 C343.54688,216.947921 344,218.052077 344,219.34375 L342.65625,219.34375 C342.65625,218.427079 342.333337,217.640628 341.6875,216.984375 C341.041663,216.328122 340.260421,216 339.34375,216 L339.34375,214.65625 Z"></path>
                      </g>
                  </g>
              </svg>
              {{ $t('index.soundcode') }}
            </div>
            <div class="card__tool card__tool--barcode" v-else-if="card.verifyType !== 4 && card.barcode.show">
              <svg class="card__tool-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h1.28v10.4H0V0zm2.24 0h1.28v10.4H2.24V0zm2.08 0H5.6v10.4H4.32V0zm1.92 0h.64v10.4h-.64V0zm1.6 0h.64v10.4h-.64V0zm2.24 0h1.76v10.4h-1.76V0zm2.88 0h1.6v10.4h-1.6V0zm2.4 0H16v10.4h-.64V0z" fill="#FFF" fill-rule="evenodd" transform="translate(0,3)"/>
              </svg>
              {{ $t('index.barcode') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <tab
      ref="tab"
      :avatar="user.avatar"
      :brand="brand.logo"
      :coupons="card.count.coupon"
      :points="points.length !== 1 ? points.length : card.count.point"
      :mulit-point="points.length > 1"
    >
    </tab>
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <transition :name="viewTransition">
          <keep-alive>
            <router-view class="nested-view" ref="nestedView" v-on:toggleCellphoneBarcode="toggleCellphoneBarcode"></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
  </main>
  <notification
    :visable="notification"
    v-on:clearNotificationBadge="clearNotificationBadge()"
    v-on:closeNotification="closeNotification()"></notification>
  <barcode
    :visable="barcode"
    :title="$t('barcode.vipBarcode')"
    :value="card.barcode.value"
    :format="card.barcode.format"
    :qrcode="true"
    :einvoiceEnable="card.einvoiceEnable"
    :einvoiceBarcode="card.einvoiceBarcode"
    :cell="user.cellFormated"
    v-on:toggleBarcode="toggleBarcode"
    v-on:toggleCellphoneBarcode="toggleCellphoneBarcode"
    :barcodeTime="card.barcode.time"
  >
  </barcode>
  <ultrasound
    v-if="card.ultrasound"
    :visable="ultrasound"
    :ultrasound-playing="ultrasoundPlaying"
    v-on:toggleUltrasound="toggleUltrasound">
  </ultrasound>

  <cellphone-barcode
    :visable="cellphoneBarcode"
    v-on:toggleModal="toggleCellphoneBarcode"
  ></cellphone-barcode>

  <vip-navigation
    v-model="visibleNavigation"
    :title="$t('index.navigationMenu')"
    :items="menuItems"
    :badge-count="user.giftNoUsedCount"
    @clickItem="handleNavigationEvents">
  </vip-navigation>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import ScrollMagic from 'scrollmagic';
import { Howl } from 'howler';

import Mixin from '@/mixins';

import Loader from '@/components/Loader.vue';
import Notification from '@/components/Notification.vue';
import Barcode from '@/components/Barcode.vue';
import Ultrasound from '@/components/Ultrasound.vue';
import Tab from '@/components/Tab.vue';
import CellphoneBarcode from '@/components/CellphoneBarcode.vue';
import VipNavigation from '@/components/VipNavigation.vue';

// 導航選單資料
const menuItemsData = [
  {
    icon: 'inventory',
    label: 'gifts.giftInbox',
  },
  {
    icon: 'aod',
    label: 'index.connectEinvoice',
  },
  {
    icon: 'description',
    label: 'index.customerJourney',
  },
  {
    icon: 'edit',
    label: 'profile.editProfile',
  },
  {
    icon: 'logout',
    label: 'common.logout',
  },
];

export default {
  name: 'Index',
  mixins: [Mixin],
  data() {
    return {
      viewTransition: '',
      viewOrder: ['Points', 'Coupons', 'Brand', 'Index'],
      notification: false,
      barcode: false,
      cellphoneBarcode: false,
      ultrasound: false,
      ultrasoundPlaying: false,
      scrollController: null,
      visibleNavigation: false,
    };
  },
  computed: {
    ...mapState([
      'loader',
      'client',
      'brand',
      'user',
      'card',
      'points',
    ]),
    ultrasoundInstance() {
      if (this.card.ultrasound) {
        return new Howl({ src: this.card.ultrasound, loop: true });
      }
      return null;
    },
    /**
     * 導航選單項目
     * @returns {Array}
     */
    menuItems() {
      return menuItemsData.filter((item) => {
        if (item.icon === 'aod' && !this.card.einvoiceEnable) {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    ...mapMutations([
      'setLoader',
      'clearNotificationCount',
    ]),
    ...mapActions([
      'getCard',
    ]),
    toggleNotification() {
      this.notification = !this.notification;

      const notificationBtn = this.$refs.notificationBtn;

      if (this.notification) {
        notificationBtn.style.top = `${notificationBtn.getBoundingClientRect().top}px`;
        notificationBtn.style.left = `${notificationBtn.getBoundingClientRect().left}px`;
        notificationBtn.style.zIndex = '1050';
        notificationBtn.style.position = 'fixed';
      } else {
        notificationBtn.removeAttribute('style');
      }
    },
    toggelVerify() {
      if (this.card.verifyType === 4 && this.card.ultrasound) {
        this.toggleUltrasound();
      } else if (this.card.verifyType !== 4 && this.card.barcode.show) {
        this.toggleBarcode();
      }
    },
    toggleBarcode() {
      this.barcode = !this.barcode;
    },
    toggleUltrasound() {
      this.ultrasoundInstance.once('play', () => {
        this.ultrasoundPlaying = true;

        this.$gtm.trackEvent({
          event: '使用音波感應',
          label: `${this.$root.$store.state.brand.name}`,
        });
      });

      this.ultrasoundInstance.once('stop', () => {
        this.ultrasoundPlaying = false;
      });

      if (!this.ultrasound) {
        this.ultrasoundInstance.play();
      } else {
        this.ultrasoundInstance.stop();
      }

      this.ultrasound = !this.ultrasound;
    },
    clearNotificationBadge() {
      this.clearNotificationCount();
    },
    closeNotification() {
      if (this.notification) {
        this.toggleNotification();
      }
    },
    toggleCellphoneBarcode() {
      this.cellphoneBarcode = !this.cellphoneBarcode;
    },
    /**
     * 處理導航選單事件 (漢堡選單)
     */
    handleNavigationEvents(item) {
      switch (item) {
        // 禮物盒
        case 'inventory':
          this.$router.push({ name: 'Gifts' });
          break;
        // 綁定手機載具
        case 'aod':
          this.visibleNavigation = false;
          this.toggleCellphoneBarcode();
          break;
        // 消費歷程
        case 'description':
          this.$router.push({ name: 'Transactions' });
          break;
        // 修改個人檔案
        case 'edit':
          this.$router.push({ name: 'Edit' });
          break;
        // 登出
        case 'logout':
          this.setLoader(true);
          this.logout();
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.setLoader(true);
  },
  mounted() {
    this.getCard();

    const backgroundHeight =
      this.$refs.header.clientHeight +
      this.$refs.card__container.clientHeight +
      78;

    this.$refs.background.style.height = `${backgroundHeight}px`;

    this.scrollController = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerHook: 0,
      triggerElement: this.$refs.card__container,
      duration: this.$refs.card__container.clientHeight * 0.9,
    })
      .on('progress', (event) => {
        this.$refs.card__container.style.opacity = 1 - event.progress;
        this.$refs.card__container.style.transform = `translate(0, -${(10 * event.progress)}%)`;
      })
      .addTo(this.scrollController);

    new ScrollMagic.Scene({
      triggerHook: 0,
      triggerElement: this.$refs.tab.$el,
    })
      .setClassToggle(this.$refs.background, 'is-fixed')
      .addTo(this.scrollController);

    new ScrollMagic.Scene({
      triggerHook: 0,
      triggerElement: this.$refs.tab.$el,
    })
      .setClassToggle(this.$refs.tab.$el, 'is-fixed')
      .setPin(this.$refs.tab.$el, { pushFollowers: false })
      .addTo(this.scrollController);
  },
  beforeDestroy() {
    this.scrollController.destroy(true);
    this.scrollController = null;
  },
  watch: {
    $route(to, from) {
      this.viewTransition = this.viewOrder.indexOf(from.name) < this.viewOrder.indexOf(to.name) ? 'slide-right' : 'slide-left';
    },
  },
  components: {
    Loader,
    Notification,
    Barcode,
    Ultrasound,
    Tab,
    CellphoneBarcode,
    VipNavigation,
  },
};
</script>

<style lang="sass" scoped>
.view
  position: relative

  margin: 0 auto

.background
  position: absolute
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: -1
  overflow: hidden

  &.is-fixed
    position: fixed
    top: auto
    bottom: 100%
    z-index: 1000

    transform: translateY(79px)

  &__overlay
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 2

    background-image: linear-gradient(0deg, rgba(40,40,40,0.85) 0%, rgba(40,40,40,0.40) 100%)

  &__image
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 1

    background-size: cover
    background-position: center top

    filter: blur(10px)

.header
  padding: 15px 10px 10px
  height: 54px

  color: white
  z-index: 1020

  .panel-enable--notification &
    z-index: 1050

  &-container
    display: flex
    position: relative

  &__left,
  &__right
    width: 60px

  &__center
    flex-grow: 1
    text-align: center

  &__left
    padding-left: 5px
    text-align: left

  &__right
    padding-right: 5px
    text-align: right

  &__title
    overflow: hidden
    margin: 0

    font-weight: bold
    font-size: 1.125em
    text-shadow: 0 1px 2px rgba(0, 0, 0, .5)
    line-height: 28px
    white-space: nowrap
    text-overflow: ellipsis

.hamburger-menu
  display: inline-block
  cursor: pointer

  &__icon
    .material-icons
      font-size: 1.125em
      line-height: 29px

.notification
  display: inline-block

  cursor: pointer

  &.is-highlighted
    .notification__count
      padding: 1px 5px

      background-color: #FD0000

      color: white

  &__icon,
  &__count
    display: inline-block
    vertical-align: middle

  &__icon
    .material-icons
      font-size: 1.125em
      line-height: 29px

  &__count
    display: inline-block
    padding: 1px 5px

    border-radius: 16px

    background-color: #FD0000

    font-size: 0.75rem
    text-align: center

main
  height: 100%
  overflow-x: hidden

.card
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 0
  overflow: hidden
  display: flex
  flex-flow: column
  justify-content: center
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .1)

  border: none

  background-size: cover

  border-radius: 6px

  color: white
  text-align: center

  &__container
    position: relative
    margin: 0 10px

    transition: opacity .25s ease

    &::before
      display: block
      padding-top: 49.85915493%

      content: ''

  &__avatar
    width: 100px
    height: 100px
    margin: 0 auto 10px
    box-shadow: 0 1px 5px 1px rgba(0, 0, 0, .4)
    overflow: hidden

    border-radius: 50%
    border: 2px solid white

    background-color: white

    img
      width: 100%
      height: auto

  &__name
    font-size: 1.125em
    font-weight: bold
    text-shadow: 0 0 2px rgba(0, 0, 0, .5)

  &__type
    font-size: 0.75rem
    text-shadow: 0 0 2px rgba(0, 0, 0, .5)

  &__tool
    position: absolute
    bottom: 10px
    text-shadow: 0 2px 4px rgba(0, 0, 0, .5)

    font-size: 0.625rem
    text-align: center

    cursor: pointer

    &--barcode
      right: 10px

    &--detail
      right: 10px

    &-icon
      display: block
      margin: 0 auto 1px

.nested-view
  min-height: calc(100vh - 80px)
  display: flex
  flex-direction: column
  // justify-content: space-between

  @media only screen and (min-width : 992px)
    border-right: 1px solid #E6E6E6
    border-left: 1px solid #E6E6E6
</style>

<style lang="sass">
.section
  &:last-child
    margin-bottom: 22px

.slide-left-enter-active,
.slide-left-leave-active
  transition: all .2s cubic-bezier(.4, 0, .2, 1)

.slide-left-enter
  opacity: 0
  transform: translateX(-100%)

.slide-left-leave-to
  opacity: 0
  position: absolute
  transform: translateX(100%)

.slide-right-enter-active,
.slide-right-leave-active
  transition: all .2s cubic-bezier(.4, 0, .2, 1)

.slide-right-enter
  opacity: 0
  transform: translateX(100%)

.slide-right-leave-to
  opacity: 0
  position: absolute
  transform: translateX(-100%)

  .nested-view
    background-color: #F7F7F7

.fade-enter-active,
.fade-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.fade-enter,
.fade-leave-to
  opacity: 0
</style>
